// extracted by mini-css-extract-plugin
export default {"card":"CardList-module--card--08445","cardType":"CardList-module--cardType--96b30"};